import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {Manufacturer} from './manufacturer';
import {BaseApi, ListFilter, ListResult, Pagination} from '@shared/base';
import {ApiUtils} from '@shared/utils/api.utils';

@Injectable({
  providedIn: 'root'
})
export class ManufacturerApi extends BaseApi<Manufacturer> {
  protected readonly httpClient: HttpClient;

  constructor() {
    const httpClient = inject(HttpClient);

    super(httpClient, 'manufacturers');
  
    this.httpClient = httpClient;
  }

  create(): Manufacturer {
    return new Manufacturer();
  }

  public findByFilter(listFilter: ListFilter, pagination: Pagination): Observable<ListResult<Manufacturer>> {
    const httpParams = ApiUtils.createHttpParams({...listFilter, ...pagination.toListFilter()});

    return this.httpClient.get<ListResult<Manufacturer>>(`${this.endpoint}/search`, {params: httpParams}).pipe(map(value => {
      value.data.forEach(manufacturer => {
        if (!manufacturer['@type']) {
          manufacturer['@type'] = 'ManufacturerDto';
        }
      });

      return Object.assign(new ListResult<Manufacturer>(), value);
    }));
  }
}
